export default function Main({children}) {
    return <main className="container px-6 mx-auto">{children}</main>
}